/* eslint-disable */
// Do not edit this file, it is auto-generated at build time!
// See scripts/generate-component-builder/index.js to modify the generation of this file.

import { ComponentBuilder } from '@sitecore-jss/sitecore-jss-react';

import AccountInfo from '../components/AccountInfo/AccountInfo';
import NewCompanyInfo from '../components/AccountInfo/NewCompanyInfo';
import Notification from '../components/AccountInfo/Notification';
import ShippingAddress from '../components/AccountInfo/ShippingAddress';
import TaxExempt from '../components/AccountInfo/TaxExempt';
import AddendaErrataSection from '../components/AddendaErrataSection/AddendaErrataSection';
import AddNewAddress from '../components/AddNewAddress/AddNewAddress';
import Auth from '../components/Auth/Auth';
import BackToTopButton from '../components/BackToTopButton/BackToTopButton';
import Cart from '../components/Cart/Cart';
import CartDisclaimer from '../components/Cart/CartDisclaimer/CartDisclaimer';
import CartPage from '../components/Cart/CartPage/CartPage';
import CartSlider from '../components/Cart/CartSlider/CartSlider';
import CartLOBListDetails from '../components/CartLOBListDetails/CartLOBListDetails';
import ChangePassword from '../components/ChangePassword/ChangePassword';
import ChangePasswordStatus from '../components/ChangePasswordStatus/ChangePasswordStatus';
import CheckoutPage from '../components/CheckoutPage/CheckoutPage';
import ProcessOrderValidationService from '../components/CheckoutPage/ProcessOrderValidationService';
import CheckoutDetails from '../components/CheckoutPage/CheckoutDetails/CheckoutDetails';
import CheckoutLogin from '../components/CheckoutPage/CheckoutLogin/CheckoutLogin';
import CodeInjection from '../components/CodeInjection/CodeInjection';
import ContactUs from '../components/ContactUs/ContactUs';
import ContentBlock from '../components/ContentBlock/ContentBlock';
import ContinueShoppingSection from '../components/ContinueShoppingSection/ContinueShoppingSection';
import Cookie from '../components/Cookie/Cookie';
import breadcrumbmanager from '../components/Coveo/breadcrumb-manager';
import didyoumean from '../components/Coveo/did-you-mean';
import engine from '../components/Coveo/engine';
import facetmanager from '../components/Coveo/facet-manager';
import facetsearch from '../components/Coveo/facet-search';
import facet from '../components/Coveo/facet';
import historymanager from '../components/Coveo/history-manager';
import interactiveresult from '../components/Coveo/interactive-result';
import pager from '../components/Coveo/pager';
import querysummary from '../components/Coveo/query-summary';
import resultlist from '../components/Coveo/result-list';
import resultsummary from '../components/Coveo/result-summary';
import resultsperpage from '../components/Coveo/results-per-page';
import searchbox from '../components/Coveo/search-box';
import searchcontrollers from '../components/Coveo/search-controllers';
import searchstatus from '../components/Coveo/search-status';
import sortcriteria from '../components/Coveo/sort-criteria';
import sort from '../components/Coveo/sort';
import staticfilter from '../components/Coveo/static-filter';
import urlmanager from '../components/Coveo/url-manager';
import constant from '../components/CreditCard/constant';
import CreditCard from '../components/CreditCard/CreditCard';
import validations from '../components/CreditCard/validations';
import CustomButton from '../components/CustomButton/CustomButton';
import CustomTooltip from '../components/CustomTooltip/CustomTooltip';
import DialogComponent from '../components/DialogComponent/DialogComponent';
import DigitalDelivery from '../components/DigitalDelivery/DigitalDelivery';
import DrilldownMenu from '../components/DrilldownMenu/DrilldownMenu';
import EULA from '../components/EULA/EULA';
import ExternalPaymentProcessing from '../components/ExternalPaymentProcessing/ExternalPaymentProcessing';
import Footer from '../components/Footer/Footer';
import GlobalSearchField from '../components/GlobalSearchField/GlobalSearchField';
import GroupPayment from '../components/GroupPayment/GroupPayment';
import Header from '../components/Header/Header';
import HeaderBanner from '../components/HeaderBanner/HeaderBanner';
import HeaderMenu from '../components/HeaderMenu/HeaderMenu';
import HelpfulTipsPage from '../components/HelpfulTipsPage/HelpfulTipsPage';
import HeroBannerWithSearch from '../components/HeroBannerWithSearch/HeroBannerWithSearch';
import ICPProductCartDetails from '../components/ICPProductCartDetails/ICPProductCartDetails';
import InfoPopup from '../components/InfoPopup/InfoPopup';
import InstructorLedSessions from '../components/InstructorLedSessions/InstructorLedSessions';
import LandingPage from '../components/LandingPage/LandingPage';
import LatestNews from '../components/LatestNews/LatestNews';
import LinkRenderer from '../components/LinkRenderer/LinkRenderer';
import LoadingIcon from '../components/LoadingIcon/LoadingIcon';
import LoadingSection from '../components/LoadingSection/LoadingSection';
import LoadingSkeleton from '../components/LoadingSkeleton/LoadingSkeleton';
import Login from '../components/Login/Login';
import Logo from '../components/Logo/Logo';
import IManageAssignments from '../components/ManageAssignments/IManageAssignments';
import ManageAssignments from '../components/ManageAssignments/ManageAssignments';
import ManageUsers from '../components/ManageUsers/ManageUsers';
import MarketingPromo from '../components/MarketingPromo/MarketingPromo';
import MobileNavigation from '../components/MobileNavigation/MobileNavigation';
import MonogramVerifonePaymentConfirmation from '../components/MonogramVerifonePaymentConfirmation/MonogramVerifonePaymentConfirmation';
import LinkList from '../components/Navigation/LinkList/LinkList';
import ScrollToTop from '../components/Navigation/ScrollToTop/ScrollToTop';
import NonInstantPayment from '../components/NonInstantPayment/NonInstantPayment';
import IOptInNotification from '../components/OptInNotification/IOptInNotification';
import OptInNotification from '../components/OptInNotification/OptInNotification';
import OrderConfirmation from '../components/Order/OrderConfirmation/OrderConfirmation';
import OrderPending from '../components/Order/OrderPending/OrderPending';
import OrderProcessing from '../components/Order/OrderProcessing/OrderProcessing';
import OrderSummary from '../components/Order/OrderSummary/OrderSummary';
import IOrderSummaryCheckout from '../components/Order/OrderSummaryCheckout/IOrderSummaryCheckout';
import OrderSummaryCheckout from '../components/Order/OrderSummaryCheckout/OrderSummaryCheckout';
import OrderUnsuccessful from '../components/Order/OrderUnsuccessful/OrderUnsuccessful';
import OrderHistory from '../components/OrderHistory/OrderHistory';
import EnrollmentKeySection from '../components/OrderHistory/EnrollmentKeySection/EnrollmentKeySection';
import OrderHistoryDropdown from '../components/OrderHistory/OrderHistoryDropdown/OrderHistoryDropdown';
import PageHero from '../components/PageHero/PageHero';
import PaymentConfirmation from '../components/PaymentConfirmation/PaymentConfirmation';
import BillingAddress from '../components/PaymentMethod/BillingAddress';
import IPayment from '../components/PaymentMethod/IPayment';
import PaymentMethod from '../components/PaymentMethod/PaymentMethod';
import PaymentPending from '../components/PaymentPending/PaymentPending';
import IPaymentReceipt from '../components/PaymentReceipt/IPaymentReceipt';
import PaymentReceipt from '../components/PaymentReceipt/PaymentReceipt';
import PaymentUnsuccessful from '../components/PaymentUnsuccessful/PaymentUnsuccessful';
import PaymentErrors from '../components/PlaceOrderProcess/PaymentErrors';
import PlaceOrderProcess from '../components/PlaceOrderProcess/PlaceOrderProcess';
import PreviewStandardImage from '../components/PreviewStandardImage/PreviewStandardImage';
import IPreviousEditions from '../components/PreviousEditionsSection/IPreviousEditions';
import PreviousEditionsSection from '../components/PreviousEditionsSection/PreviousEditionsSection';
import PreviousYearSection from '../components/PreviousYearSection/PreviousYearSection';
import PriceOptions from '../components/PriceOptions/PriceOptions';
import ProductDescriptionSection from '../components/Product/ProductDescriptionSection/ProductDescriptionSection';
import ProductDetails from '../components/Product/ProductDetails/ProductDetails';
import ProductMetaData from '../components/Product/ProductMetaData/ProductMetaData';
import ProductSalesPrice from '../components/Product/ProductSalesPrice/ProductSalesPrice';
import StandardProductCartDetails from '../components/Product/StandardProductCartDetails/StandardProductCartDetails';
import PromotionalBanner from '../components/PromotionalBanner/PromotionalBanner';
import Quantity from '../components/Quantity/Quantity';
import QuantityPicker from '../components/QuantityPicker/QuantityPicker';
import RecipientEmail from '../components/RecipientEmail/RecipientEmail';
import RelatedPrograms from '../components/RelatedPrograms/RelatedPrograms';
import ResponsiveImage from '../components/ResponsiveImage/ResponsiveImage';
import IReturnReceipt from '../components/ReturnReceipt/IReturnReceipt';
import ReturnReceipt from '../components/ReturnReceipt/ReturnReceipt';
import IReviewOrder from '../components/ReviewCartOrder/IReviewOrder';
import ReviewCartOrder from '../components/ReviewCartOrder/ReviewCartOrder';
import RichTextEditor from '../components/RichTextEditor/RichTextEditor';
import RichToastNotification from '../components/RichToastNotification/RichToastNotification';
import SearchField from '../components/SearchField/SearchField';
import SearchPage from '../components/SearchPage/SearchPage';
import SecondaryHeaderMenu from '../components/SecondaryHeaderMenu/SecondaryHeaderMenu';
import ShareLinkDialog from '../components/ShareLinkDialog/ShareLinkDialog';
import AddressListPopup from '../components/ShippingInformation/AddressListPopup';
import IShippingInformation from '../components/ShippingInformation/IShippingInformation';
import ShippingInformation from '../components/ShippingInformation/ShippingInformation';
import SignoutPage from '../components/SignoutPage/SignoutPage';
import SkipToContent from '../components/SkipToContent/SkipToContent';
import SocialFooter from '../components/SocialFooter/SocialFooter';
import StatisticsStore from '../components/StatisticsStore/StatisticsStore';
import StatisticsStoreMenu from '../components/StatisticsStoreMenu/StatisticsStoreMenu';
import StatisticsStorePage from '../components/StatisticsStorePage/StatisticsStorePage';
import FourColumnContentRow from '../components/SubLayouts/FourColumnContentRow/FourColumnContentRow';
import OneColumn from '../components/SubLayouts/OneColumn/OneColumn';
import OneColumnContentRowFullWidth from '../components/SubLayouts/OneColumnContentRowFullWidth/OneColumnContentRowFullWidth';
import OneColumnContentRowWithMargins from '../components/SubLayouts/OneColumnContentRowWithMargins/OneColumnContentRowWithMargins';
import PartialDesignDynamicPlaceholder from '../components/SubLayouts/PartialDesignDynamicPlaceholder/PartialDesignDynamicPlaceholder';
import SectionFullWidth from '../components/SubLayouts/SectionFullWidth/SectionFullWidth';
import SectionWithMargin from '../components/SubLayouts/SectionWithMargin/SectionWithMargin';
import ThreeColumnContentRow from '../components/SubLayouts/ThreeColumnContentRow/ThreeColumnContentRow';
import TwoColumnContentRow from '../components/SubLayouts/TwoColumnContentRow/TwoColumnContentRow';
import TwoColumnwithLeftNav from '../components/SubLayouts/TwoColumnwithLeftNav/TwoColumnwithLeftNav';
import SubmitPaymentProcess from '../components/SubmitPaymentProcess/SubmitPaymentProcess';
import SubmitProcessValidationService from '../components/SubmitPaymentProcess/SubmitProcessValidationService';
import SubscriptionBanner from '../components/Subscription/SubscriptionBanner/SubscriptionBanner';
import SubscriptionDetailsPage from '../components/Subscription/SubscriptionDetailsPage/SubscriptionDetailsPage';
import SubscriptionGlobalSearchField from '../components/Subscription/SubscriptionGlobalSearchField/SubscriptionGlobalSearchField';
import SubscriptionHeroBannerWithSearch from '../components/Subscription/SubscriptionHeroBannerWithSearch/SubscriptionHeroBannerWithSearch';
import SubscriptionLanguageOptions from '../components/Subscription/SubscriptionLanguageOptions/SubscriptionLanguageOptions';
import SubscriptionLogo from '../components/Subscription/SubscriptionLogo/SubscriptionLogo';
import SubscriptionProductDetails from '../components/Subscription/SubscriptionProductDetails/SubscriptionProductDetails';
import SubscriptionSearchField from '../components/Subscription/SubscriptionSearchField/SubscriptionSearchField';
import searchparametermanager from '../components/Subscription/SubscriptionSearchPage/search-parameter-manager';
import subscriptioninteractiveresult from '../components/Subscription/SubscriptionSearchPage/subscription-interactive-result';
import subscriptionresultlist from '../components/Subscription/SubscriptionSearchPage/subscription-result-list';
import subscriptionsearchbox from '../components/Subscription/SubscriptionSearchPage/subscription-search-box';
import subscriptionsengine from '../components/Subscription/SubscriptionSearchPage/subscriptions-engine';
import subscriptionssearchcontrollers from '../components/Subscription/SubscriptionSearchPage/subscriptions-search-controllers';
import SubscriptionSearchPage from '../components/Subscription/SubscriptionSearchPage/SubscriptionSearchPage';
import SubscriptionStandardOption from '../components/Subscription/SubscriptionStandardOption/SubscriptionStandardOption';
import SubscriptionValidation from '../components/Subscription/SubscriptionValidation/SubscriptionValidation';
import TaxExemptStatus from '../components/TaxExemptStatus/TaxExemptStatus';
import ToastNotification from '../components/ToastNotification/ToastNotification';
import TrainingProductCartDetails from '../components/TrainingProductCartDetails/TrainingProductCartDetails';
import TrendingStandards from '../components/TrendingStandards/TrendingStandards';
import TwitterWidget from '../components/TwitterWidget/TwitterWidget';
import UnifiedCartFooter from '../components/UnifiedCartFooter/UnifiedCartFooter';
import UnifiedHeader from '../components/UnifiedHeader/UnifiedHeader';
import UnifiedHeaderLogo from '../components/UnifiedHeaderLogo/UnifiedHeaderLogo';
import UnifiedPaymentDetails from '../components/UnifiedPaymentDetails/UnifiedPaymentDetails';
import UnifiedPaymentInvoiceSection from '../components/UnifiedPaymentInvoiceSection/UnifiedPaymentInvoiceSection';
import UnifiedPaymentInvoiceSummary from '../components/UnifiedPaymentInvoiceSummary/UnifiedPaymentInvoiceSummary';
import UnifiedPaymentPage from '../components/UnifiedPaymentPage/UnifiedPaymentPage';
import UnifiedPaymentReceipt from '../components/UnifiedPaymentReceipt/UnifiedPaymentReceipt';
import UploadTaxExempt from '../components/UploadTaxExempt/UploadTaxExempt';
import WebstoreRetailHelpfulTips from '../components/WebstoreRetailHelpfulTips/WebstoreRetailHelpfulTips';

const components = new Map();

components.set('AccountInfo', AccountInfo);
components.set('NewCompanyInfo', NewCompanyInfo);
components.set('Notification', Notification);
components.set('ShippingAddress', ShippingAddress);
components.set('TaxExempt', TaxExempt);
components.set('AddendaErrataSection', AddendaErrataSection);
components.set('AddNewAddress', AddNewAddress);
components.set('Auth', Auth);
components.set('BackToTopButton', BackToTopButton);
components.set('Cart', Cart);
components.set('CartDisclaimer', CartDisclaimer);
components.set('CartPage', CartPage);
components.set('CartSlider', CartSlider);
components.set('CartLOBListDetails', CartLOBListDetails);
components.set('ChangePassword', ChangePassword);
components.set('ChangePasswordStatus', ChangePasswordStatus);
components.set('CheckoutPage', CheckoutPage);
components.set('ProcessOrderValidationService', ProcessOrderValidationService);
components.set('CheckoutDetails', CheckoutDetails);
components.set('CheckoutLogin', CheckoutLogin);
components.set('CodeInjection', CodeInjection);
components.set('ContactUs', ContactUs);
components.set('ContentBlock', ContentBlock);
components.set('ContinueShoppingSection', ContinueShoppingSection);
components.set('Cookie', Cookie);
components.set('breadcrumb-manager', breadcrumbmanager);
components.set('did-you-mean', didyoumean);
components.set('engine', engine);
components.set('facet-manager', facetmanager);
components.set('facet-search', facetsearch);
components.set('facet', facet);
components.set('history-manager', historymanager);
components.set('interactive-result', interactiveresult);
components.set('pager', pager);
components.set('query-summary', querysummary);
components.set('result-list', resultlist);
components.set('result-summary', resultsummary);
components.set('results-per-page', resultsperpage);
components.set('search-box', searchbox);
components.set('search-controllers', searchcontrollers);
components.set('search-status', searchstatus);
components.set('sort-criteria', sortcriteria);
components.set('sort', sort);
components.set('static-filter', staticfilter);
components.set('url-manager', urlmanager);
components.set('constant', constant);
components.set('CreditCard', CreditCard);
components.set('validations', validations);
components.set('CustomButton', CustomButton);
components.set('CustomTooltip', CustomTooltip);
components.set('DialogComponent', DialogComponent);
components.set('DigitalDelivery', DigitalDelivery);
components.set('DrilldownMenu', DrilldownMenu);
components.set('EULA', EULA);
components.set('ExternalPaymentProcessing', ExternalPaymentProcessing);
components.set('Footer', Footer);
components.set('GlobalSearchField', GlobalSearchField);
components.set('GroupPayment', GroupPayment);
components.set('Header', Header);
components.set('HeaderBanner', HeaderBanner);
components.set('HeaderMenu', HeaderMenu);
components.set('HelpfulTipsPage', HelpfulTipsPage);
components.set('HeroBannerWithSearch', HeroBannerWithSearch);
components.set('ICPProductCartDetails', ICPProductCartDetails);
components.set('InfoPopup', InfoPopup);
components.set('InstructorLedSessions', InstructorLedSessions);
components.set('LandingPage', LandingPage);
components.set('LatestNews', LatestNews);
components.set('LinkRenderer', LinkRenderer);
components.set('LoadingIcon', LoadingIcon);
components.set('LoadingSection', LoadingSection);
components.set('LoadingSkeleton', LoadingSkeleton);
components.set('Login', Login);
components.set('Logo', Logo);
components.set('IManageAssignments', IManageAssignments);
components.set('ManageAssignments', ManageAssignments);
components.set('ManageUsers', ManageUsers);
components.set('MarketingPromo', MarketingPromo);
components.set('MobileNavigation', MobileNavigation);
components.set('MonogramVerifonePaymentConfirmation', MonogramVerifonePaymentConfirmation);
components.set('LinkList', LinkList);
components.set('ScrollToTop', ScrollToTop);
components.set('NonInstantPayment', NonInstantPayment);
components.set('IOptInNotification', IOptInNotification);
components.set('OptInNotification', OptInNotification);
components.set('OrderConfirmation', OrderConfirmation);
components.set('OrderPending', OrderPending);
components.set('OrderProcessing', OrderProcessing);
components.set('OrderSummary', OrderSummary);
components.set('IOrderSummaryCheckout', IOrderSummaryCheckout);
components.set('OrderSummaryCheckout', OrderSummaryCheckout);
components.set('OrderUnsuccessful', OrderUnsuccessful);
components.set('OrderHistory', OrderHistory);
components.set('EnrollmentKeySection', EnrollmentKeySection);
components.set('OrderHistoryDropdown', OrderHistoryDropdown);
components.set('PageHero', PageHero);
components.set('PaymentConfirmation', PaymentConfirmation);
components.set('BillingAddress', BillingAddress);
components.set('IPayment', IPayment);
components.set('PaymentMethod', PaymentMethod);
components.set('PaymentPending', PaymentPending);
components.set('IPaymentReceipt', IPaymentReceipt);
components.set('PaymentReceipt', PaymentReceipt);
components.set('PaymentUnsuccessful', PaymentUnsuccessful);
components.set('PaymentErrors', PaymentErrors);
components.set('PlaceOrderProcess', PlaceOrderProcess);
components.set('PreviewStandardImage', PreviewStandardImage);
components.set('IPreviousEditions', IPreviousEditions);
components.set('PreviousEditionsSection', PreviousEditionsSection);
components.set('PreviousYearSection', PreviousYearSection);
components.set('PriceOptions', PriceOptions);
components.set('ProductDescriptionSection', ProductDescriptionSection);
components.set('ProductDetails', ProductDetails);
components.set('ProductMetaData', ProductMetaData);
components.set('ProductSalesPrice', ProductSalesPrice);
components.set('StandardProductCartDetails', StandardProductCartDetails);
components.set('PromotionalBanner', PromotionalBanner);
components.set('Quantity', Quantity);
components.set('QuantityPicker', QuantityPicker);
components.set('RecipientEmail', RecipientEmail);
components.set('RelatedPrograms', RelatedPrograms);
components.set('ResponsiveImage', ResponsiveImage);
components.set('IReturnReceipt', IReturnReceipt);
components.set('ReturnReceipt', ReturnReceipt);
components.set('IReviewOrder', IReviewOrder);
components.set('ReviewCartOrder', ReviewCartOrder);
components.set('RichTextEditor', RichTextEditor);
components.set('RichToastNotification', RichToastNotification);
components.set('SearchField', SearchField);
components.set('SearchPage', SearchPage);
components.set('SecondaryHeaderMenu', SecondaryHeaderMenu);
components.set('ShareLinkDialog', ShareLinkDialog);
components.set('AddressListPopup', AddressListPopup);
components.set('IShippingInformation', IShippingInformation);
components.set('ShippingInformation', ShippingInformation);
components.set('SignoutPage', SignoutPage);
components.set('SkipToContent', SkipToContent);
components.set('SocialFooter', SocialFooter);
components.set('StatisticsStore', StatisticsStore);
components.set('StatisticsStoreMenu', StatisticsStoreMenu);
components.set('StatisticsStorePage', StatisticsStorePage);
components.set('FourColumnContentRow', FourColumnContentRow);
components.set('OneColumn', OneColumn);
components.set('OneColumnContentRowFullWidth', OneColumnContentRowFullWidth);
components.set('OneColumnContentRowWithMargins', OneColumnContentRowWithMargins);
components.set('PartialDesignDynamicPlaceholder', PartialDesignDynamicPlaceholder);
components.set('SectionFullWidth', SectionFullWidth);
components.set('SectionWithMargin', SectionWithMargin);
components.set('ThreeColumnContentRow', ThreeColumnContentRow);
components.set('TwoColumnContentRow', TwoColumnContentRow);
components.set('TwoColumnwithLeftNav', TwoColumnwithLeftNav);
components.set('SubmitPaymentProcess', SubmitPaymentProcess);
components.set('SubmitProcessValidationService', SubmitProcessValidationService);
components.set('SubscriptionBanner', SubscriptionBanner);
components.set('SubscriptionDetailsPage', SubscriptionDetailsPage);
components.set('SubscriptionGlobalSearchField', SubscriptionGlobalSearchField);
components.set('SubscriptionHeroBannerWithSearch', SubscriptionHeroBannerWithSearch);
components.set('SubscriptionLanguageOptions', SubscriptionLanguageOptions);
components.set('SubscriptionLogo', SubscriptionLogo);
components.set('SubscriptionProductDetails', SubscriptionProductDetails);
components.set('SubscriptionSearchField', SubscriptionSearchField);
components.set('search-parameter-manager', searchparametermanager);
components.set('subscription-interactive-result', subscriptioninteractiveresult);
components.set('subscription-result-list', subscriptionresultlist);
components.set('subscription-search-box', subscriptionsearchbox);
components.set('subscriptions-engine', subscriptionsengine);
components.set('subscriptions-search-controllers', subscriptionssearchcontrollers);
components.set('SubscriptionSearchPage', SubscriptionSearchPage);
components.set('SubscriptionStandardOption', SubscriptionStandardOption);
components.set('SubscriptionValidation', SubscriptionValidation);
components.set('TaxExemptStatus', TaxExemptStatus);
components.set('ToastNotification', ToastNotification);
components.set('TrainingProductCartDetails', TrainingProductCartDetails);
components.set('TrendingStandards', TrendingStandards);
components.set('TwitterWidget', TwitterWidget);
components.set('UnifiedCartFooter', UnifiedCartFooter);
components.set('UnifiedHeader', UnifiedHeader);
components.set('UnifiedHeaderLogo', UnifiedHeaderLogo);
components.set('UnifiedPaymentDetails', UnifiedPaymentDetails);
components.set('UnifiedPaymentInvoiceSection', UnifiedPaymentInvoiceSection);
components.set('UnifiedPaymentInvoiceSummary', UnifiedPaymentInvoiceSummary);
components.set('UnifiedPaymentPage', UnifiedPaymentPage);
components.set('UnifiedPaymentReceipt', UnifiedPaymentReceipt);
components.set('UploadTaxExempt', UploadTaxExempt);
components.set('WebstoreRetailHelpfulTips', WebstoreRetailHelpfulTips);

const componentBuilder = new ComponentBuilder({ components });

export const componentFactory = componentBuilder.getComponentFactory();
